import { useEffect } from "react";
import { nanoid } from "nanoid";
import { useSearchParams } from "react-router-dom";

export const useUser = () => {
  let [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get("id");

  useEffect(() => {
    const user_id = localStorage.getItem("user_id");
    if (!user_id) {
      if (id) {
        localStorage.setItem("user_id", id);
      } else {
        localStorage.setItem("user_id", `us${nanoid()}`);
      }
    }
  }, []);
};
